"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionTabsJSONModel = void 0;
const AbstractItemsJSONModel_1 = require("src/hello_assets/src/components/model/common/abstractItems/AbstractItemsJSONModel");
const EventJSONModel_1 = require("src/hello_assets/src/components/model/common/event/EventJSONModel");
const QueryEventVariantsJSONModel_1 = require("src/hello_assets/src/components/model/common/queryEventVariant/QueryEventVariantsJSONModel");
const QueryEventVariantJSONModel_1 = require("src/hello_assets/src/components/model/common/queryEventVariant/QueryEventVariantJSONModel");
class RetentionTabsJSONModel extends AbstractItemsJSONModel_1.AbstractItemsJSONModel {
    constructor(serializedState) {
        super(serializedState, {
            serialize: serialize,
            deserialize: deserialize
        });
        this.addEmptyTab = (makeActive) => {
            const cohortQueryJSONModel = new QueryEventVariantsJSONModel_1.QueryEventVariantsJSONModel();
            const cohortQueryEventVariantJSONModel = new QueryEventVariantJSONModel_1.QueryEventVariantJSONModel();
            cohortQueryEventVariantJSONModel.setValueAsEventJSONModel(new EventJSONModel_1.EventJSONModel());
            cohortQueryJSONModel.addQueryEventVariantJSONModel(cohortQueryEventVariantJSONModel);
            const returnQueryJSONModel = new QueryEventVariantsJSONModel_1.QueryEventVariantsJSONModel();
            const returnQueryEventVariantJSONModel = new QueryEventVariantJSONModel_1.QueryEventVariantJSONModel();
            returnQueryEventVariantJSONModel.setValueAsEventJSONModel(new EventJSONModel_1.EventJSONModel());
            returnQueryJSONModel.addQueryEventVariantJSONModel(returnQueryEventVariantJSONModel);
            return this.addItem(serialize({
                cohortQueryJSONModel: cohortQueryJSONModel,
                returnQueryJSONModel: returnQueryJSONModel,
            }), makeActive);
        };
        this.getCohortJSONModel = (uniqueId) => {
            var _a;
            return (_a = this.getItem(uniqueId)) === null || _a === void 0 ? void 0 : _a.data.cohortQueryJSONModel;
        };
        this.getReturnJSONModel = (uniqueId) => {
            var _a;
            return (_a = this.getItem(uniqueId)) === null || _a === void 0 ? void 0 : _a.data.returnQueryJSONModel;
        };
    }
}
exports.RetentionTabsJSONModel = RetentionTabsJSONModel;
const serialize = (deserializedValue) => {
    return {
        cohort: deserializedValue.cohortQueryJSONModel.serialize(),
        return: deserializedValue.returnQueryJSONModel.serialize(),
    };
};
const deserialize = (serializedValue) => {
    const cohortQueryJSONModel = new QueryEventVariantsJSONModel_1.QueryEventVariantsJSONModel(serializedValue.cohort);
    const returnQueryJSONModel = new QueryEventVariantsJSONModel_1.QueryEventVariantsJSONModel(serializedValue.return);
    return {
        cohortQueryJSONModel: cohortQueryJSONModel,
        returnQueryJSONModel: returnQueryJSONModel,
    };
};
